import type { InvitesAction } from './actions';
import { InvitesActionTypes } from './actionTypes';

import type { Invite, SendInviteError } from '@cobliteam/common-types';

import { type WebData, webDataError, webDataFetching, webDataNotAsked, webDataSuccess } from '@cobliteam/api-lib';

export interface InvitesState {
  loadInvitesWebData: WebData<Invite[]>;
  sendInvitesWebData: WebData<void>;
  deleteInviteWebData: WebData<void>;
  validationErrors?: SendInviteError;
}

export const invitesInitialState: InvitesState = {
  loadInvitesWebData: webDataNotAsked(),
  sendInvitesWebData: webDataNotAsked(),
  deleteInviteWebData: webDataNotAsked(),
};

export const invitesReducer = (state: InvitesState = invitesInitialState, action: InvitesAction): InvitesState => {
  switch (action.type) {
    case InvitesActionTypes.LOAD_INVITES_REQUEST:
      return {
        ...state,
        loadInvitesWebData: webDataFetching(),
      };

    case InvitesActionTypes.LOAD_INVITES_SUCCEEDED:
      return {
        ...state,
        loadInvitesWebData: webDataSuccess(action.payload),
      };

    case InvitesActionTypes.LOAD_INVITES_FAILED:
      return {
        ...state,
        loadInvitesWebData: webDataError(),
      };

    case InvitesActionTypes.SEND_INVITES_REQUEST:
      return {
        ...state,
        sendInvitesWebData: webDataFetching(),
      };

    case InvitesActionTypes.SEND_INVITES_SUCCEEDED:
      return {
        ...state,
        sendInvitesWebData: webDataSuccess(undefined),
      };

    case InvitesActionTypes.SEND_INVITES_FAILED:
      return {
        ...state,
        sendInvitesWebData: webDataError(),
        validationErrors: action.payload,
      };

    case InvitesActionTypes.DELETE_INVITE_REQUEST:
      return {
        ...state,
        deleteInviteWebData: webDataFetching(),
      };

    case InvitesActionTypes.DELETE_INVITE_SUCCEEDED:
      return {
        ...state,
        deleteInviteWebData: webDataSuccess(undefined),
      };

    case InvitesActionTypes.DELETE_INVITE_FAILED:
      return {
        ...state,
        deleteInviteWebData: webDataError(),
      };

    default:
      return state;
  }
};
